/**
 * AP-38-E — **Wenn der Server die Einrichtung verlangt.**
 *
 * Nach der Frist antworten das Erneuern des Tokens und der Firmenwechsel mit
 * `403 TWO_FACTOR_SETUP_REQUIRED` und einem Ticket (Entscheidung 8.6: keine Sperre,
 * aber kein Weiter ohne). Dann geht es auf die Seite der Einrichtung; das Ticket
 * wartet dort im `sessionStorage` dieses Tabs, das Ziel danach ebenso.
 */

const TICKET = 'symphenia.2fa-ticket';
const ZIEL = 'symphenia.2fa-ziel';
export const EINRICHTEN_PFAD = '/zwei-faktor-einrichten';

/** Verlangt dieser Fehler die Einrichtung? Dann merkt er sich Ticket und Ziel, leitet um und sagt `true`. */
export function verlangtEinrichtung(err: unknown): boolean {
  const daten = (err as { response?: { status?: number; data?: { code?: string; ticket?: string } } })?.response;
  if (daten?.status !== 403 || daten.data?.code !== 'TWO_FACTOR_SETUP_REQUIRED' || !daten.data.ticket) return false;
  try {
    sessionStorage.setItem(TICKET, daten.data.ticket);
    if (!window.location.pathname.startsWith(EINRICHTEN_PFAD)) {
      sessionStorage.setItem(ZIEL, `${window.location.pathname}${window.location.search}${window.location.hash}`);
    }
  } catch {
    // Ohne Speicher bleibt nur die Anmeldung — die verlangt die Einrichtung ebenso.
  }
  if (!window.location.pathname.startsWith(EINRICHTEN_PFAD)) window.location.href = EINRICHTEN_PFAD;
  return true;
}

export function einrichtungsTicket(): string | null {
  try {
    return sessionStorage.getItem(TICKET);
  } catch {
    return null;
  }
}

/** Nach der Einrichtung: Ticket vergessen, Ziel zurückgeben. */
export function einrichtungErledigt(): string {
  try {
    const ziel = sessionStorage.getItem(ZIEL) ?? '/';
    sessionStorage.removeItem(TICKET);
    sessionStorage.removeItem(ZIEL);
    return ziel;
  } catch {
    return '/';
  }
}
